import React from 'react';
import PropTypes from 'prop-types';
import useDeviceIntelligence from '../../Hooks/useDeviceIntelligence';

const DeviceIntelligenceCollector = ({ user }) => {
  useDeviceIntelligence(user);
  return null;
};

DeviceIntelligenceCollector.propTypes = {
  user: PropTypes.object,
};

const DeviceIntelligenceProvider = () => {
  const userState = window.__INITIAL_STATE?.user;
  const orgState = window.__INITIAL_STATE?.organization;
  
  const user = userState ? {
    id: userState.user_id,
    email: userState.email,
    fullName: `${userState.first_name || ''} ${userState.last_name || ''}`.trim(),
    organizationId: orgState?.org_id,
    organizationName: orgState?.name,
    isInternal: false,
  } : null;

  return <DeviceIntelligenceCollector user={user} />;
};

export default DeviceIntelligenceProvider;
